module.exports = __webpack_public_path__ + "img/IMG_9321_L_Black_MockedUp.5f60ac51.jpg";